let initialState = {
  // typeOption: '',
  // currentDate: '',
  // accountNum: ''
  typeOption: ''
}

export default function typeOptionReducer (state: any = initialState, action:any) {
  let {type, payload} = action
  switch(type) {
    case 'iRPASFSOP1':
    case 'iRPASFSOP2':
    case 'iRPASFSOP3':
      return state = {
        typeOption: payload
      }
    default:
      return state
  }
}